export enum ModalTypes {
  gameCenter = "gameCenter",
  addGames = "addGames",
  editGame = "editGame",
  gameSession = "gameSession",
  segment = "segment",
  player = "player",
  addToSegment = "addToSegment",
  wager = "wager",
  addGamesToWager = "addGamesToWager",
  bonus = "bonus",
  loyaltyLevel = "loyaltyLevel",
  loyaltyPoints = "loyaltyPoints",
  depositPointLimit = "depositPointLimit",
  notification = "notification",
  notificationSend = "notificationSend",
  banners = "banners",
  provider = "provider",
  paymentProvider = "paymentProvider",
  paymentMethod = "paymentMethod",
  operationsDetails = "operationsDetails",
  createDeposit = "createDeposit",
  createWithdrawal = "createWithdrawal",
  createCompensation = "createCompensation",
  selectPlayer = "selectPlayer",
  createConfiscation = "createConfiscation",
  premium = "premium",
  promoCode = "promoCode",
  cashback = "cashback",
  page = "page",
  seo = "seo",
  faq = "faq",
  cashbackGames = "cashbackGames",
  addGamesToCashback = "addGamesToCashback",
  tournaments = "tournaments",
  addGamesToTournament = "addGamesToTournament",
  promo = "promo",
  email = "email",
  zone = "zone",
  mirrorEdit = "mirrorEdit",
  mirrorCreate = "mirrorCreate",
  guide = "guide",
  country = "country",
  partner = "partner",
  socialNetwork = "socialNetwork",
  applications = "applications",
  mainText = "mainText",
  brandCore = "brandCore",
  payments = "payments",
  channels = "channels",
  threads = "threads",

  riskPermission = "riskPermission",
  riskLimit = "riskLimit",
  riskKycPresets = "riskKycPresets",
  riskKycRules = "riskKycRules",
  contentPreview = "contentPreview",
  customized = "customized",
  presets = "presets",
  scheduler = "scheduler",
  multiScope = "multiScope",
}
export enum ModalDefTabs {
  main = "main",
  local = "locales",
  restrictions = "restrictions",
  settings = "settings",
  rewards = "rewards",
  content = "content",
}
export enum ModalTournamentsTabs {
  main = "main",
  rules = "rules",
  scores = "scores",
  rewards = "rewards",
  locales = "locales",
  games = "games",
}
export enum ModalCasbackGamesTabs {
  main = "main",
  games = "games",
  settings = "settings",
}
export enum ModalCasbackTabs {
  main = "main",
  config = "config",
  settings = "settings",
}
export enum ModalPageTabs {
  main = "main",
  local = "locales",
  settings = "settings",
  trail = "trail",
}
export enum ModalSeoTabs {
  main = "main",
  seo = "seo",
}
export enum ModalFaqTabs {
  main = "main",
  faq = "faq",
}

export enum ModalBrandCoreTabs {
  main = "main",
  trail = "trail",
}

export enum ModaPaymentProvidersTabs {
  main = "main",
  config = "config",
  local = "locales",
  restrictions = "restrictions",
  settings = "settings",
}

export enum ModalBannersTabs {
  main = "main",
  banners = "banners",
  settings = "settings",
  trail = "trail",
}
export enum ModalPromoTabs {
  main = "main",
  banners = "banners",
  local = "locales",
  settings = "settings",
  trail = "trail",
}

export enum ModalBonusTabs {
  main = "main",
  settings = "settings",
  timing = "timing",
  restrictions = "restrictions",
  locales = "locales",
}

export enum ModalBonusSettingsTabs {
  activationRules = "activationRules",
  rewards = "rewards",
  betsRange = "betsRange",
}

export enum ModalGameGeoTabs {
  collections = "collections",
  tags = "tags",
  tournaments = "tournaments",
  jackpots = "jackpots",
}

export enum ModalWagerTabs {
  info = "info",
  games = "games",
  settings = "settings",
}

export enum ModalPlayerTabs {
  infoUser = "info",
  bets = "bets",
  finance = "finance",
  liveOps = "liveOps",
  verification = "verification",
  risk = "risk",
  notes = "notes",
  activities = "activities",
}
export enum ModalPlayerFinanceTabs {
  deposits = "deposits",
  withdrawal = "withdrawals",
  compensations = "compensations",
  confiscations = "confiscations",
  limits = "limits",
  settings = "settings",
}

export enum ModalPlayerInfoTabs {
  main = "main",
  restrictions = "restrictions",
  notifications = "notifications",
  settings = "settings",
  wagering = "wagering",
}
export enum ModalPlayerVerificationTabs {
  profileData = "profileData",
  idCard = "idCard",
  driversLicense = "driversLicense",
  passport = "passport",
  residencePermit = "residencePermit",
}
export enum ModalPlayerRiskTabs {
  profile = "profile",
  restrictions = "restrictions",
  calculated = "calculated",
}
export enum ModalPlayerLiveOpsTabs {
  bonuses = "bonuses",
  loyalty = "loyalty",
  tournaments = "tournaments",
  cashBacks = "cashBacks",
  promoCodes = "promoCodes",
}

export enum ModalSegmentTabs {
  infoUser = "infoUser",
  players = "players",
  notifications = "notifications",
  rules = "rules",
  settings = "settings",
}

export enum ModalSegmentRulesTabs {
  payments = "payments",
  bets = "bets",
  activity = "activity",
  games = "games",
  bonuse = "bonuses",
  platform = "platform",
}

export enum ModalOperationsTabs {
  details = "details",
  ledger = "ledger",
}

export enum ModalProvidersTabs {
  main = "main",
  currencies = "currencies",
  seo = "SEO",
  restriction = "restriction",
  trail = "trail",
  locales = "locales",
}

export enum ModalGameCenterTabs {
  main = "main",
  games = "games",
  seo = "SEO",
  locales = "locales",
  restriction = "restriction",
  settings = "settings",
  trail = "trail",
}

export enum ModalGameEditTabs {
  main = "main",
  geo = "geo",
  seo = "SEO",
  freeSpins = "freeSpins",
  settings = "settings",
  trail = "trail",
}

export enum ModalMainTextTabs {
  main = "main",
  local = "locales",
  trail = "trail",
}
export enum ModalPaymentsTabs {
  main = "main",
  trail = "trail",
}

export enum GameCenterFormTypes {
  tag = "tag",
  collection = "collection",
  category = "category",
}

export enum FilterItemTypes {
  multiselect = "multiselect",
  datePicker = "datePicker",
  radio = "radio",
  select = "select",
  input = "input",
  chipInput = "chipInput",
}
export enum ModalCustomizedTabs {
  main = "main",
  items = "items",
  locales = "locales",
}

export enum ModalPresetsTabs {
  main = "main",
  lobby = "lobby",
  signUp = "signUp",
  cashier = "cashier",
}

export enum ModalNotificationTabs {
  main = "main",
  locales = "locales",
  send = "send",
}

export enum ModalPromocodesTabs {
  main = "main",
  mask = "mask",
}

export enum ModalPlayerBetsTabs {
  casino = "casino",
  sport = "sport",
}

export enum ModalRiskKycPresentTabs {
  main = "main",
  rules = "rules",
}

export enum ModalRiskKycRulesTabs {
  main = "main",
  config = "config",
}

export interface FilterItem {
  type: FilterItemTypes;
  title: string;
  boxTitle: string;
  icon: string;
  disabled?: boolean;
  activeItems?: { value: string | number; label: string }[];
  itemsArray?: { value: string | number; label: string }[];
  handleApply?: (
    e: { value: string | number; label: string }[],
    isDelete?: boolean,
  ) => void;
  onDeleteItem?: (value: string) => void;
  firstDatePlaceholder?: string;
  secondDatePlaceholder?: string;
  firstDateInitValue?: string;
  secondDateInitValue?: string;
  inputValue?: string;
  inputType?: string;
  inputPlaceholder?: string;
  setInputValue?: (e: string) => void;
  secondInputValue?: string;
  secondBoxTitle?: string;
  setSecondInputValue?: (e: string) => void;
  handleApplyDate?: (firstDate: string, secondDate?: string) => void;
}

export interface ILocaleData {
  domain?: string;
  geo: string;
  locale: string;
  title: string;
  promoLabel?: string;
  content: string;
  isActive: boolean;
}

export enum ModalChannelsTabs {
  main = "Main",
  settings = "Settings",
}

export enum ModalSchedulerTabs {
  main = "Main",
}
